import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  buttonContainer: (active: boolean) => ({
    display: 'flex',
    marginLeft: ['25px', '25px', '25px', '25px', '30px'],
    position: 'relative',
    cursor: active ? 'pointer' : 'default',
    height: '32px',
    '&:hover': {
      cursor: 'pointer'
    },
    '.number-badge': {
      ...reusables.mainTransition('color', 'ease-in', '.1s')
    },
    '&:hover .number-badge, &:focus .number-badge': {
      color: theme.rawColors.neutralBlack
    }
  }),
  badge: (color: string, totalQuantity: number) => ({
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.smallText,
    fontWeight: theme.fontWeights.normal,
    lineHeight: '120%',
    position: 'absolute',
    left: '50%',
    transform: 'translate(calc(-50% + 2px))',
    top: totalQuantity < 100 ? '-4px' : '-10px',
    color: `${color}`
  })
};